module.exports = __webpack_public_path__ + "static/img/13.4b63ce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/13.jpg
// module id = fFeI
// module chunks = 0